import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import CheckType from "@/utils/CheckType";
import { onMounted, ref, toRefs, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Audio',
  props: {
  item: {
    type: [Object],
  },
  url: String,
},
  emits: ["setAudioUrl"],
  setup(__props, { emit }) {

const props = __props;


const audioTime = ref(0);
const audioImg = ref("");

const direction = props.item.correlationState ? "left" : "right";
onMounted(() => {
  audioImg.value = "/assets/" + direction + ".png";
  let audio = new Audio(CheckType.isImg(props.item.link));
  audio.currentTime = 10000000 * Math.random();
  const countAudioTime = async () => {
    while (isNaN(audio.duration) || audio.duration === Infinity) {
      await new Promise((resolve) => setTimeout(resolve, 200));
      audio.currentTime = 10000000 * Math.random();
    }
    audioTime.value = audio.duration;
  };
  countAudioTime();
});
const musicAudio: any = ref();
let playTime = null;
const { url } = toRefs(props);
watch(url, () => {
  if (props.url != CheckType.isImg(props.item.link)) {
    if (musicAudio.value) {
      musicAudio.value.pause();
      audioImg.value = "/assets/" + direction + ".png";
    }
  }
});
// 播放MP3image.png
const audioPlay = (url, time) => {
  clearTimeout(playTime);
  if (audioImg.value.includes("png")) {
    audioImg.value = "/assets/" + direction + ".gif";
    emit("setAudioUrl", url);
    musicAudio.value = new Audio(url);
    musicAudio.value.play();
    playTime = setTimeout(() => {
      musicAudio.value = null;
      audioImg.value = "/assets/" + direction + ".png";
    }, time * 1000);
  } else {
    musicAudio.value.pause();
    musicAudio.value = null;
    audioImg.value = "/assets/" + direction + ".png";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "audio",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (audioPlay(_unref(CheckType).isImg(props.item.link), audioTime.value)))
  }, [
    _createTextVNode(_toDisplayString(Math.floor(audioTime.value) + '"'), 1),
    _createElementVNode("img", {
      class: "mp3",
      src: audioImg.value,
      alt: ""
    }, null, 8, _hoisted_1)
  ]))
}
}

})